<template>
  <div class="hero-section">
    <div class="hero-content">
      <h2 class="title">Los mejores padres no tienen todas las respuestas. 
Tienen nuevas herramientas.</h2>
      <p class="description-hero text-center">
        Talentinus te ayuda a entender a tu hijo, descubrir su camino ideal —universidad o certificación— y construir juntos un futuro con propósito, sin decisiones costosas ni al azar. Comienza gratis sin compromiso.
      </p>
      <a
        class="cta-button"
        href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
        target="_blank"
        rel="noopener"
      >
        INICIAR CONVERSACIÓN
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',
  methods: {
    handleClick() {
      // Handle button click event
      console.log('Diagnóstico button clicked')
    }
  }
}
</script>

<style scoped>
.hero-section {
  width: 100%;
  height: 840px;
  background: url('../../assets/img/enhanced_image.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.hero-content {
  display: flex;
  max-height: 1400px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}

@media (max-width: 768px) {
  .hero-section {
    height: auto !important;
    min-height: 420px;
    padding: 12px !important;
    background-position: center top;
  }
  .hero-content {
    gap: 16px !important;
    padding: 0 !important;
  }
  .title {
    font-size: 22px !important;
    padding: 0 8px !important;
    margin: 16px 0 !important;
  }
  .description-hero {
    font-size: 14px !important;
    padding: 0 8px !important;
    margin: 8px 0 !important;
  }
  .cta-button {
    width: 90vw !important;
    min-width: 120px !important;
    font-size: 14px !important;
    height: 44px !important;
    padding: 0 !important;
  }
}
</style>
